
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93Ik6nucHBUPMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/[...slug].vue?macro=true";
import { default as dashboard3xg5DHPgqlMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/analytics/dashboard.vue?macro=true";
import { default as market_monitoringwoMKXxYmCjMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/analytics/market_monitoring.vue?macro=true";
import { default as indexyGGafjBrkzMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/analytics/monitoring-coverage/index.vue?macro=true";
import { default as reports171mYp1vn4Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/analytics/reports.vue?macro=true";
import { default as saleskoJWGBkQ7GMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/analytics/sales.vue?macro=true";
import { default as indexsfj4CpXrpZMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/docs/marketing-event/index.vue?macro=true";
import { default as indexZE6FK0ur6KMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/index.vue?macro=true";
import { default as errorsKHafTVv4ebMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/integration/errors.vue?macro=true";
import { default as mycosttypesKkrgNMcwmNMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/integration/mycosttypes.vue?macro=true";
import { default as rates8DyiV65vkHMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/integration/rates.vue?macro=true";
import { default as indexlSUrcAQJGkMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/integration/repricing-schedule/index.vue?macro=true";
import { default as upload_productsKi0Oqom0jpMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/integration/upload_products.vue?macro=true";
import { default as uploadsalesjYItCVG4bmMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/integration/uploadsales.vue?macro=true";
import { default as loginR3FlbgpGNcMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/login.vue?macro=true";
import { default as indexkvaGYGqOIzMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/card-types/index.vue?macro=true";
import { default as propUCCFTxv3UDMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/card-types/prop.vue?macro=true";
import { default as indexnTxP92MgwzMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/cards/index.vue?macro=true";
import { default as prop9rlNVBS6cFMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/cards/prop.vue?macro=true";
import { default as index5cJBP0jtTRMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/clients/index.vue?macro=true";
import { default as prop2xKJk0DbngMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/clients/prop.vue?macro=true";
import { default as indexH5xfYEnnizMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/event-schedule/index.vue?macro=true";
import { default as index3iBvPivdaQMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/event-types/index.vue?macro=true";
import { default as propUMsj8UMLjfMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/event-types/prop.vue?macro=true";
import { default as indexf0MWRahDSgMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/events/index.vue?macro=true";
import { default as propDW7kS6JW3qMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/events/prop.vue?macro=true";
import { default as indexUKWrKSlV3EMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/log/index.vue?macro=true";
import { default as indexFr4085mlI6Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/parameters/index.vue?macro=true";
import { default as propYuj3OnAdfWMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/parameters/prop.vue?macro=true";
import { default as indexwQoDclnv7NMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/politics/index.vue?macro=true";
import { default as propHOO63NR3FQMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/politics/prop.vue?macro=true";
import { default as indexR6iDhAWegCMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/rules/index.vue?macro=true";
import { default as propoRnoPM1ioNMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/rules/prop.vue?macro=true";
import { default as indexNwt3eUkMmYMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/value-parameters/index.vue?macro=true";
import { default as propEyqmVtEeJRMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/value-parameters/prop.vue?macro=true";
import { default as indexgF1EWqTHH5Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/badge/index.vue?macro=true";
import { default as propXhy1E80S8SMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/badge/prop.vue?macro=true";
import { default as indexVCtl2GasleMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/card-types/index.vue?macro=true";
import { default as propKiTIW0WKDuMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/card-types/prop.vue?macro=true";
import { default as indexLHakT15nfVMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/cards/index.vue?macro=true";
import { default as propNkRYFinPpwMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/cards/prop.vue?macro=true";
import { default as indexs1mJS9CmJRMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/clients/index.vue?macro=true";
import { default as propgSy0BKApKdMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/clients/prop.vue?macro=true";
import { default as indexbqWMoixeFQMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/commercial-parameters/index.vue?macro=true";
import { default as propJy0CnPxN2SMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/commercial-parameters/prop.vue?macro=true";
import { default as indexWxrvDhIBtxMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/commercial-priorities/index.vue?macro=true";
import { default as propNatwA13LuoMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/commercial-priorities/prop.vue?macro=true";
import { default as indexnEgk8lGHV9Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/commercial-rules/index.vue?macro=true";
import { default as propxMvNSePrWWMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/commercial-rules/prop.vue?macro=true";
import { default as index9RWGORNgsqMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/event-types/index.vue?macro=true";
import { default as propHzLvdz8l2UMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/event-types/prop.vue?macro=true";
import { default as indexXx4U2HOdcwMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/events/index.vue?macro=true";
import { default as propQnSmQHKT9wMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/events/prop.vue?macro=true";
import { default as indexsawI4G59FzMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/parameters/index.vue?macro=true";
import { default as propjANmFd6xEDMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/parameters/prop.vue?macro=true";
import { default as index4Dnr3IW0QLMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/params-history/index.vue?macro=true";
import { default as propUM62fr89vzMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/params-history/prop.vue?macro=true";
import { default as indexKqfuzfsdZYMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/politics/index.vue?macro=true";
import { default as propcu1sVTJa8eMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/politics/prop.vue?macro=true";
import { default as indexfbVhWvZcPOMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/promo-code/index.vue?macro=true";
import { default as propgxOuzkSDdQMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/promo-code/prop.vue?macro=true";
import { default as index6hLSsQq1yMMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/sales-channel/index.vue?macro=true";
import { default as propZfBv2ybFacMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/sales-channel/prop.vue?macro=true";
import { default as indexphBOCh9p2XMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/trigger/index.vue?macro=true";
import { default as propXxKqIJY9cbMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/trigger/prop.vue?macro=true";
import { default as indexQsiissOcToMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/value-parameters/index.vue?macro=true";
import { default as propA7mNjcZKzVMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/value-parameters/prop.vue?macro=true";
import { default as indexBp3DNgi0UdMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/badge/index.vue?macro=true";
import { default as propv73CBbzJRwMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/badge/prop.vue?macro=true";
import { default as indexqhMDFXACAqMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/commercial-parameters/index.vue?macro=true";
import { default as propYUnUAaJWhgMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/commercial-parameters/prop.vue?macro=true";
import { default as indexgnq8a3DRsXMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/commercial-priorities/index.vue?macro=true";
import { default as prop4w8eQsIYTXMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/commercial-priorities/prop.vue?macro=true";
import { default as indexmPo1ICxPneMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/commercial-rules/index.vue?macro=true";
import { default as proplyExN53zZhMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/commercial-rules/prop.vue?macro=true";
import { default as index8mEEjsBYdTMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/conditions/index.vue?macro=true";
import { default as propq5tvwH2wWdMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/conditions/prop.vue?macro=true";
import { default as indexaHStHuEvVZMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/event-types/index.vue?macro=true";
import { default as propm1RJaBetPMMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/event-types/prop.vue?macro=true";
import { default as indexmq65MQNgM0Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/event/index.vue?macro=true";
import { default as propqzEe4SqWnrMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/event/prop.vue?macro=true";
import { default as index1BFobaaAnvMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/parameters/index.vue?macro=true";
import { default as propItZ6A0JhV3Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/parameters/prop.vue?macro=true";
import { default as indexvp8YjzY4jwMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/politics/index.vue?macro=true";
import { default as propOVQhthFfEwMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/politics/prop.vue?macro=true";
import { default as indexwI9hg5PMpHMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/promo-code/index.vue?macro=true";
import { default as prop7kkNxYmDf1Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/promo-code/prop.vue?macro=true";
import { default as indexJngXjRPxqxMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/rule-priority/index.vue?macro=true";
import { default as propkucukHodQKMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/rule-priority/prop.vue?macro=true";
import { default as indexlIDvPiSauuMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/rules/index.vue?macro=true";
import { default as prop6I7ACOe9buMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/rules/prop.vue?macro=true";
import { default as index2brQfnIKmLMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/sales-channel/index.vue?macro=true";
import { default as propcnYmOwqRRSMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/sales-channel/prop.vue?macro=true";
import { default as indexQOMsNRG2CfMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/value-parameters/index.vue?macro=true";
import { default as propLYhgxhXCRpMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/value-parameters/prop.vue?macro=true";
import { default as indexTYfLnk74DiMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrent-pricetypes/index.vue?macro=true";
import { default as propDy1W5lwpTCMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrent-pricetypes/prop.vue?macro=true";
import { default as indexCD9YWx73OCMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrent-product-statuses/index.vue?macro=true";
import { default as propFcXrqlrWdOMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrent-product-statuses/prop.vue?macro=true";
import { default as indexIWruzI97I6Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrent-regions/index.vue?macro=true";
import { default as propgj5BMcbmrJMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrent-regions/prop.vue?macro=true";
import { default as indexa8k40wlcj7Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrents/index.vue?macro=true";
import { default as proppLsjuuMqyOMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrents/prop.vue?macro=true";
import { default as indexBIPRMABTN9Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/product-matching/index.vue?macro=true";
import { default as propf8JEM1mTbvMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/product-matching/prop.vue?macro=true";
import { default as indexNU3W7mGAAeMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/providers/index.vue?macro=true";
import { default as propwID3TVLL7VMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/providers/prop.vue?macro=true";
import { default as indexO6pWZizbumMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/autoallocation/index.vue?macro=true";
import { default as propLngxhYhkuvMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/autoallocation/prop.vue?macro=true";
import { default as indexoOwEOCjGTJMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/balance/index.vue?macro=true";
import { default as index3ttZrab0BmMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/bbalance-supplier/index.vue?macro=true";
import { default as groupProp5uWB9f6S7kMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/catalog/groupProp.vue?macro=true";
import { default as indexSQl5uWKydtMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/catalog/index.vue?macro=true";
import { default as productProprE8PewhnaMMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/catalog/productProp.vue?macro=true";
import { default as index7ieV4EWeX4Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/corrections/index.vue?macro=true";
import { default as mergeNIlVQI9Ur4Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/corrections/merge.vue?macro=true";
import { default as propY7qTrENPpiMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/corrections/prop.vue?macro=true";
import { default as errorscJmsWVhDoEMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/errors.vue?macro=true";
import { default as firstcalcxWkwKVGGnLMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/firstcalc.vue?macro=true";
import { default as fix_45prices_45propOSPedzFTxTMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/fix-prices/fix-prices-prop.vue?macro=true";
import { default as indexWBkrclSrlYMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/fix-prices/index.vue?macro=true";
import { default as prices_45propmKHRWBUlyUMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/fix-prices/prices-prop.vue?macro=true";
import { default as pricesPlEuYKQFYZMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/fix-prices/prices.vue?macro=true";
import { default as index5H0Y5xI83JMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/groups/index.vue?macro=true";
import { default as propKR2KHfXt3HMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/groups/prop.vue?macro=true";
import { default as detail9aEg4LxkboMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/manualrepricing/detail.vue?macro=true";
import { default as index3tZSPIj4RNMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/manualrepricing/index.vue?macro=true";
import { default as indexlWGSgNnddgMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/monitoring/index.vue?macro=true";
import { default as indexjSnfxE9CagMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/politics/index.vue?macro=true";
import { default as propdmJHH7uvPXMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/politics/prop.vue?macro=true";
import { default as indexGX4Y37ki74Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/postponed/index.vue?macro=true";
import { default as indexTGoNxBfZGZMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/prices/index.vue?macro=true";
import { default as proptDQYNNY5FEMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/prices/prop.vue?macro=true";
import { default as indexGkDcQGFzNnMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/pricetypes/index.vue?macro=true";
import { default as propJ7BqnoW0SgMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/pricetypes/prop.vue?macro=true";
import { default as indexggiRw5Ps3ZMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/products/index.vue?macro=true";
import { default as propZb3zBLaGljMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/products/prop.vue?macro=true";
import { default as indexx0xcuVRRGkMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/regions/index.vue?macro=true";
import { default as prophPmQ1Fz1bYMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/regions/prop.vue?macro=true";
import { default as regularpricing1CX7bmiahZMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/regularpricing.vue?macro=true";
import { default as index6C1Pvsea4SMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/stock/index.vue?macro=true";
import { default as propaHRq7Rq4GbMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/stock/prop.vue?macro=true";
import { default as indexXmTKjFVormMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/supplier/index.vue?macro=true";
import { default as propFsveTjoguKMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/supplier/prop.vue?macro=true";
import { default as indexQalnEgG2AVMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/unallocated-products/index.vue?macro=true";
import { default as indexZfl6oLDldOMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/profile/profile/index.vue?macro=true";
import { default as indexZQSf4WlgYUMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/functions/index.vue?macro=true";
import { default as propfUFcR29LCXMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/functions/prop.vue?macro=true";
import { default as indexVcWXR57HkRMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/grouptypes/index.vue?macro=true";
import { default as propi0iIrJD78GMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/grouptypes/prop.vue?macro=true";
import { default as index46dapMyHblMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/monitoring-settings/index.vue?macro=true";
import { default as indexIZMh3gToWgMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/parameters/index.vue?macro=true";
import { default as proplqyEt6Qx0XMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/parameters/prop.vue?macro=true";
import { default as indexDc64akjVVnMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/price-event/index.vue?macro=true";
import { default as indexyjZSswXvFhMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/price-levels/index.vue?macro=true";
import { default as propYQSm29kKRrMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/price-levels/prop.vue?macro=true";
import { default as indexshY4i4Z3UNMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/pricetype-groups/index.vue?macro=true";
import { default as prop4FyeOUqhprMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/pricetype-groups/prop.vue?macro=true";
import { default as indexh7NnXxJV5YMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/product-statuses/index.vue?macro=true";
import { default as propqt3b0BlZr8Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/product-statuses/prop.vue?macro=true";
import { default as indexMCkEp2HSXWMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/region-groups/index.vue?macro=true";
import { default as prop3VpiIskIRGMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/region-groups/prop.vue?macro=true";
import { default as index4RcQXRJaiMMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/repricing-options/index.vue?macro=true";
import { default as propGPegFlyiolMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/repricing-options/prop.vue?macro=true";
import { default as indexYFHP4458d6Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/schedule/index.vue?macro=true";
import { default as proplWnER8NWOAMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/schedule/prop.vue?macro=true";
import { default as index2H5xQ1JCodMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/stock-levels/index.vue?macro=true";
import { default as propzDfcdtMcAGMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/stock-levels/prop.vue?macro=true";
import { default as indexZrFE8vcaD2Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/tables/index.vue?macro=true";
import { default as propxcabObEzo9Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/tables/prop.vue?macro=true";
import { default as index32CIVbZ5xHMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/tabletypes/index.vue?macro=true";
import { default as propp9XpuX1xYYMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/tabletypes/prop.vue?macro=true";
import { default as indexgwzJEzngdfMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/value-parameters/index.vue?macro=true";
import { default as propte95tmKQ4BMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/value-parameters/prop.vue?macro=true";
import { default as indexX2fwLY8ZbdMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/analytic/index.vue?macro=true";
import { default as indexjQF0X0cWMZMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/constellation/index.vue?macro=true";
import { default as propR6Ylqx33UfMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/constellation/prop.vue?macro=true";
import { default as indexwpmrXZwz4nMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/management/index.vue?macro=true";
import { default as indexnfyzKJXjVpMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/module/index.vue?macro=true";
import { default as propkNRTdx67CIMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/module/prop.vue?macro=true";
import { default as indexrVS7yVjYtwMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/shop/index.vue?macro=true";
import { default as propZMOu4u0FsWMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/shop/prop.vue?macro=true";
import { default as indexmhYgYIrJzRMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/showcase/index.vue?macro=true";
import { default as proplC6wwAX3gMMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/showcase/prop.vue?macro=true";
import { default as index5qgHYo5D9DMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/template/index.vue?macro=true";
import { default as prop44Lf557NruMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/template/prop.vue?macro=true";
import { default as index0b4cUkGgj6Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/type-module/index.vue?macro=true";
import { default as propDoAcMQ6dHOMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/type-module/prop.vue?macro=true";
import { default as indexaSQjGoqwZCMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/type-showcase/index.vue?macro=true";
import { default as proprRTxYyNUqhMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/type-showcase/prop.vue?macro=true";
import { default as indexh48rVG5KDtMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/systemsetting/access/index.vue?macro=true";
import { default as indexuZwLNWaxkUMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/function-test/index.vue?macro=true";
import { default as indexpIiqsJWbIQMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/loyalty-politic-test/index.vue?macro=true";
import { default as index43zSUIOsxIMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/marketing-politic-test/index.vue?macro=true";
import { default as indexmETUkT4mI7Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/miner/index.vue?macro=true";
import { default as detailrritHD8xUwMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/politic-test/detail.vue?macro=true";
import { default as index1f2NyOBsIkMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/politic-test/index.vue?macro=true";
import { default as indexd3GltQrTBxMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/price-level-test/index.vue?macro=true";
import { default as indexCZGrSZyBDEMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/snake/index.vue?macro=true";
import { default as indexGorhAYrIXDMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/some/index.vue?macro=true";
import { default as indexGzhf2tcGPqMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/tetris/index.vue?macro=true";
import { default as assignedN82q9rUoFpMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/workspace/assigned.vue?macro=true";
import { default as inboxlNDblMcu59Meta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/workspace/inbox.vue?macro=true";
import { default as tasks1Wio7sciVqMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/workspace/tasks.vue?macro=true";
import { default as teamhQUyNHjagWMeta } from "/var/www/pricing.bigam-dev.ru/data/www/client/pages/workspace/team.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/[...slug].vue")
  },
  {
    name: "analytics-dashboard",
    path: "/analytics/dashboard",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/analytics/dashboard.vue")
  },
  {
    name: "analytics-market_monitoring",
    path: "/analytics/market_monitoring",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/analytics/market_monitoring.vue")
  },
  {
    name: "analytics-monitoring-coverage",
    path: "/analytics/monitoring-coverage",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/analytics/monitoring-coverage/index.vue")
  },
  {
    name: "analytics-reports",
    path: "/analytics/reports",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/analytics/reports.vue")
  },
  {
    name: "analytics-sales",
    path: "/analytics/sales",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/analytics/sales.vue")
  },
  {
    name: "docs-marketing-event",
    path: "/docs/marketing-event",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/docs/marketing-event/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/index.vue")
  },
  {
    name: "integration-errors",
    path: "/integration/errors",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/integration/errors.vue")
  },
  {
    name: "integration-mycosttypes",
    path: "/integration/mycosttypes",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/integration/mycosttypes.vue")
  },
  {
    name: "integration-rates",
    path: "/integration/rates",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/integration/rates.vue")
  },
  {
    name: "integration-repricing-schedule",
    path: "/integration/repricing-schedule",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/integration/repricing-schedule/index.vue")
  },
  {
    name: "integration-upload_products",
    path: "/integration/upload_products",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/integration/upload_products.vue")
  },
  {
    name: "integration-uploadsales",
    path: "/integration/uploadsales",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/integration/uploadsales.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginR3FlbgpGNcMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/login.vue")
  },
  {
    name: "loyalty-card-types",
    path: "/loyalty/card-types",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/card-types/index.vue")
  },
  {
    name: "loyalty-card-types-prop",
    path: "/loyalty/card-types/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/card-types/prop.vue")
  },
  {
    name: "loyalty-cards",
    path: "/loyalty/cards",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/cards/index.vue")
  },
  {
    name: "loyalty-cards-prop",
    path: "/loyalty/cards/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/cards/prop.vue")
  },
  {
    name: "loyalty-clients",
    path: "/loyalty/clients",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/clients/index.vue")
  },
  {
    name: "loyalty-clients-prop",
    path: "/loyalty/clients/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/clients/prop.vue")
  },
  {
    name: "loyalty-event-schedule",
    path: "/loyalty/event-schedule",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/event-schedule/index.vue")
  },
  {
    name: "loyalty-event-types",
    path: "/loyalty/event-types",
    meta: index3iBvPivdaQMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/event-types/index.vue")
  },
  {
    name: "loyalty-event-types-prop",
    path: "/loyalty/event-types/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/event-types/prop.vue")
  },
  {
    name: "loyalty-events",
    path: "/loyalty/events",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/events/index.vue")
  },
  {
    name: "loyalty-events-prop",
    path: "/loyalty/events/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/events/prop.vue")
  },
  {
    name: "loyalty-log",
    path: "/loyalty/log",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/log/index.vue")
  },
  {
    name: "loyalty-parameters",
    path: "/loyalty/parameters",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/parameters/index.vue")
  },
  {
    name: "loyalty-parameters-prop",
    path: "/loyalty/parameters/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/parameters/prop.vue")
  },
  {
    name: "loyalty-politics",
    path: "/loyalty/politics",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/politics/index.vue")
  },
  {
    name: "loyalty-politics-prop",
    path: "/loyalty/politics/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/politics/prop.vue")
  },
  {
    name: "loyalty-rules",
    path: "/loyalty/rules",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/rules/index.vue")
  },
  {
    name: "loyalty-rules-prop",
    path: "/loyalty/rules/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/rules/prop.vue")
  },
  {
    name: "loyalty-value-parameters",
    path: "/loyalty/value-parameters",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/value-parameters/index.vue")
  },
  {
    name: "loyalty-value-parameters-prop",
    path: "/loyalty/value-parameters/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/loyalty/value-parameters/prop.vue")
  },
  {
    name: "marketing-new-badge",
    path: "/marketing-new/badge",
    meta: indexgF1EWqTHH5Meta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/badge/index.vue")
  },
  {
    name: "marketing-new-badge-prop",
    path: "/marketing-new/badge/prop",
    meta: propXhy1E80S8SMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/badge/prop.vue")
  },
  {
    name: "marketing-new-card-types",
    path: "/marketing-new/card-types",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/card-types/index.vue")
  },
  {
    name: "marketing-new-card-types-prop",
    path: "/marketing-new/card-types/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/card-types/prop.vue")
  },
  {
    name: "marketing-new-cards",
    path: "/marketing-new/cards",
    meta: indexLHakT15nfVMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/cards/index.vue")
  },
  {
    name: "marketing-new-cards-prop",
    path: "/marketing-new/cards/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/cards/prop.vue")
  },
  {
    name: "marketing-new-clients",
    path: "/marketing-new/clients",
    meta: indexs1mJS9CmJRMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/clients/index.vue")
  },
  {
    name: "marketing-new-clients-prop",
    path: "/marketing-new/clients/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/clients/prop.vue")
  },
  {
    name: "marketing-new-commercial-parameters",
    path: "/marketing-new/commercial-parameters",
    meta: indexbqWMoixeFQMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/commercial-parameters/index.vue")
  },
  {
    name: "marketing-new-commercial-parameters-prop",
    path: "/marketing-new/commercial-parameters/prop",
    meta: propJy0CnPxN2SMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/commercial-parameters/prop.vue")
  },
  {
    name: "marketing-new-commercial-priorities",
    path: "/marketing-new/commercial-priorities",
    meta: indexWxrvDhIBtxMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/commercial-priorities/index.vue")
  },
  {
    name: "marketing-new-commercial-priorities-prop",
    path: "/marketing-new/commercial-priorities/prop",
    meta: propNatwA13LuoMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/commercial-priorities/prop.vue")
  },
  {
    name: "marketing-new-commercial-rules",
    path: "/marketing-new/commercial-rules",
    meta: indexnEgk8lGHV9Meta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/commercial-rules/index.vue")
  },
  {
    name: "marketing-new-commercial-rules-prop",
    path: "/marketing-new/commercial-rules/prop",
    meta: propxMvNSePrWWMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/commercial-rules/prop.vue")
  },
  {
    name: "marketing-new-event-types",
    path: "/marketing-new/event-types",
    meta: index9RWGORNgsqMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/event-types/index.vue")
  },
  {
    name: "marketing-new-event-types-prop",
    path: "/marketing-new/event-types/prop",
    meta: propHzLvdz8l2UMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/event-types/prop.vue")
  },
  {
    name: "marketing-new-events",
    path: "/marketing-new/events",
    meta: indexXx4U2HOdcwMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/events/index.vue")
  },
  {
    name: "marketing-new-events-prop",
    path: "/marketing-new/events/prop",
    meta: propQnSmQHKT9wMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/events/prop.vue")
  },
  {
    name: "marketing-new-parameters",
    path: "/marketing-new/parameters",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/parameters/index.vue")
  },
  {
    name: "marketing-new-parameters-prop",
    path: "/marketing-new/parameters/prop",
    meta: propjANmFd6xEDMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/parameters/prop.vue")
  },
  {
    name: "marketing-new-params-history",
    path: "/marketing-new/params-history",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/params-history/index.vue")
  },
  {
    name: "marketing-new-params-history-prop",
    path: "/marketing-new/params-history/prop",
    meta: propUM62fr89vzMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/params-history/prop.vue")
  },
  {
    name: "marketing-new-politics",
    path: "/marketing-new/politics",
    meta: indexKqfuzfsdZYMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/politics/index.vue")
  },
  {
    name: "marketing-new-politics-prop",
    path: "/marketing-new/politics/prop",
    meta: propcu1sVTJa8eMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/politics/prop.vue")
  },
  {
    name: "marketing-new-promo-code",
    path: "/marketing-new/promo-code",
    meta: indexfbVhWvZcPOMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/promo-code/index.vue")
  },
  {
    name: "marketing-new-promo-code-prop",
    path: "/marketing-new/promo-code/prop",
    meta: propgxOuzkSDdQMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/promo-code/prop.vue")
  },
  {
    name: "marketing-new-sales-channel",
    path: "/marketing-new/sales-channel",
    meta: index6hLSsQq1yMMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/sales-channel/index.vue")
  },
  {
    name: "marketing-new-sales-channel-prop",
    path: "/marketing-new/sales-channel/prop",
    meta: propZfBv2ybFacMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/sales-channel/prop.vue")
  },
  {
    name: "marketing-new-trigger",
    path: "/marketing-new/trigger",
    meta: indexphBOCh9p2XMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/trigger/index.vue")
  },
  {
    name: "marketing-new-trigger-prop",
    path: "/marketing-new/trigger/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/trigger/prop.vue")
  },
  {
    name: "marketing-new-value-parameters",
    path: "/marketing-new/value-parameters",
    meta: indexQsiissOcToMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/value-parameters/index.vue")
  },
  {
    name: "marketing-new-value-parameters-prop",
    path: "/marketing-new/value-parameters/prop",
    meta: propA7mNjcZKzVMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing-new/value-parameters/prop.vue")
  },
  {
    name: "marketing-badge",
    path: "/marketing/badge",
    meta: indexBp3DNgi0UdMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/badge/index.vue")
  },
  {
    name: "marketing-badge-prop",
    path: "/marketing/badge/prop",
    meta: propv73CBbzJRwMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/badge/prop.vue")
  },
  {
    name: "marketing-commercial-parameters",
    path: "/marketing/commercial-parameters",
    meta: indexqhMDFXACAqMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/commercial-parameters/index.vue")
  },
  {
    name: "marketing-commercial-parameters-prop",
    path: "/marketing/commercial-parameters/prop",
    meta: propYUnUAaJWhgMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/commercial-parameters/prop.vue")
  },
  {
    name: "marketing-commercial-priorities",
    path: "/marketing/commercial-priorities",
    meta: indexgnq8a3DRsXMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/commercial-priorities/index.vue")
  },
  {
    name: "marketing-commercial-priorities-prop",
    path: "/marketing/commercial-priorities/prop",
    meta: prop4w8eQsIYTXMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/commercial-priorities/prop.vue")
  },
  {
    name: "marketing-commercial-rules",
    path: "/marketing/commercial-rules",
    meta: indexmPo1ICxPneMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/commercial-rules/index.vue")
  },
  {
    name: "marketing-commercial-rules-prop",
    path: "/marketing/commercial-rules/prop",
    meta: proplyExN53zZhMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/commercial-rules/prop.vue")
  },
  {
    name: "marketing-conditions",
    path: "/marketing/conditions",
    meta: index8mEEjsBYdTMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/conditions/index.vue")
  },
  {
    name: "marketing-conditions-prop",
    path: "/marketing/conditions/prop",
    meta: propq5tvwH2wWdMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/conditions/prop.vue")
  },
  {
    name: "marketing-event-types",
    path: "/marketing/event-types",
    meta: indexaHStHuEvVZMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/event-types/index.vue")
  },
  {
    name: "marketing-event-types-prop",
    path: "/marketing/event-types/prop",
    meta: propm1RJaBetPMMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/event-types/prop.vue")
  },
  {
    name: "marketing-event",
    path: "/marketing/event",
    meta: indexmq65MQNgM0Meta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/event/index.vue")
  },
  {
    name: "marketing-event-prop",
    path: "/marketing/event/prop",
    meta: propqzEe4SqWnrMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/event/prop.vue")
  },
  {
    name: "marketing-parameters",
    path: "/marketing/parameters",
    meta: index1BFobaaAnvMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/parameters/index.vue")
  },
  {
    name: "marketing-parameters-prop",
    path: "/marketing/parameters/prop",
    meta: propItZ6A0JhV3Meta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/parameters/prop.vue")
  },
  {
    name: "marketing-politics",
    path: "/marketing/politics",
    meta: indexvp8YjzY4jwMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/politics/index.vue")
  },
  {
    name: "marketing-politics-prop",
    path: "/marketing/politics/prop",
    meta: propOVQhthFfEwMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/politics/prop.vue")
  },
  {
    name: "marketing-promo-code",
    path: "/marketing/promo-code",
    meta: indexwI9hg5PMpHMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/promo-code/index.vue")
  },
  {
    name: "marketing-promo-code-prop",
    path: "/marketing/promo-code/prop",
    meta: prop7kkNxYmDf1Meta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/promo-code/prop.vue")
  },
  {
    name: "marketing-rule-priority",
    path: "/marketing/rule-priority",
    meta: indexJngXjRPxqxMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/rule-priority/index.vue")
  },
  {
    name: "marketing-rule-priority-prop",
    path: "/marketing/rule-priority/prop",
    meta: propkucukHodQKMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/rule-priority/prop.vue")
  },
  {
    name: "marketing-rules",
    path: "/marketing/rules",
    meta: indexlIDvPiSauuMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/rules/index.vue")
  },
  {
    name: "marketing-rules-prop",
    path: "/marketing/rules/prop",
    meta: prop6I7ACOe9buMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/rules/prop.vue")
  },
  {
    name: "marketing-sales-channel",
    path: "/marketing/sales-channel",
    meta: index2brQfnIKmLMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/sales-channel/index.vue")
  },
  {
    name: "marketing-sales-channel-prop",
    path: "/marketing/sales-channel/prop",
    meta: propcnYmOwqRRSMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/sales-channel/prop.vue")
  },
  {
    name: "marketing-value-parameters",
    path: "/marketing/value-parameters",
    meta: indexQOMsNRG2CfMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/value-parameters/index.vue")
  },
  {
    name: "marketing-value-parameters-prop",
    path: "/marketing/value-parameters/prop",
    meta: propLYhgxhXCRpMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/marketing/value-parameters/prop.vue")
  },
  {
    name: "monitoring-concurrent-pricetypes",
    path: "/monitoring/concurrent-pricetypes",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrent-pricetypes/index.vue")
  },
  {
    name: "monitoring-concurrent-pricetypes-prop",
    path: "/monitoring/concurrent-pricetypes/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrent-pricetypes/prop.vue")
  },
  {
    name: "monitoring-concurrent-product-statuses",
    path: "/monitoring/concurrent-product-statuses",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrent-product-statuses/index.vue")
  },
  {
    name: "monitoring-concurrent-product-statuses-prop",
    path: "/monitoring/concurrent-product-statuses/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrent-product-statuses/prop.vue")
  },
  {
    name: "monitoring-concurrent-regions",
    path: "/monitoring/concurrent-regions",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrent-regions/index.vue")
  },
  {
    name: "monitoring-concurrent-regions-prop",
    path: "/monitoring/concurrent-regions/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrent-regions/prop.vue")
  },
  {
    name: "monitoring-concurrents",
    path: "/monitoring/concurrents",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrents/index.vue")
  },
  {
    name: "monitoring-concurrents-prop",
    path: "/monitoring/concurrents/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/concurrents/prop.vue")
  },
  {
    name: "monitoring-product-matching",
    path: "/monitoring/product-matching",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/product-matching/index.vue")
  },
  {
    name: "monitoring-product-matching-prop",
    path: "/monitoring/product-matching/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/product-matching/prop.vue")
  },
  {
    name: "monitoring-providers",
    path: "/monitoring/providers",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/providers/index.vue")
  },
  {
    name: "monitoring-providers-prop",
    path: "/monitoring/providers/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/monitoring/providers/prop.vue")
  },
  {
    name: "pricing-autoallocation",
    path: "/pricing/autoallocation",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/autoallocation/index.vue")
  },
  {
    name: "pricing-autoallocation-prop",
    path: "/pricing/autoallocation/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/autoallocation/prop.vue")
  },
  {
    name: "pricing-balance",
    path: "/pricing/balance",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/balance/index.vue")
  },
  {
    name: "pricing-bbalance-supplier",
    path: "/pricing/bbalance-supplier",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/bbalance-supplier/index.vue")
  },
  {
    name: "pricing-catalog-groupProp",
    path: "/pricing/catalog/groupProp",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/catalog/groupProp.vue")
  },
  {
    name: "pricing-catalog",
    path: "/pricing/catalog",
    meta: indexSQl5uWKydtMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/catalog/index.vue")
  },
  {
    name: "pricing-catalog-productProp",
    path: "/pricing/catalog/productProp",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/catalog/productProp.vue")
  },
  {
    name: "pricing-corrections",
    path: "/pricing/corrections",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/corrections/index.vue")
  },
  {
    name: "pricing-corrections-merge",
    path: "/pricing/corrections/merge",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/corrections/merge.vue")
  },
  {
    name: "pricing-corrections-prop",
    path: "/pricing/corrections/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/corrections/prop.vue")
  },
  {
    name: "pricing-errors",
    path: "/pricing/errors",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/errors.vue")
  },
  {
    name: "pricing-firstcalc",
    path: "/pricing/firstcalc",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/firstcalc.vue")
  },
  {
    name: "pricing-fix-prices-fix-prices-prop",
    path: "/pricing/fix-prices/fix-prices-prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/fix-prices/fix-prices-prop.vue")
  },
  {
    name: "pricing-fix-prices",
    path: "/pricing/fix-prices",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/fix-prices/index.vue")
  },
  {
    name: "pricing-fix-prices-prices-prop",
    path: "/pricing/fix-prices/prices-prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/fix-prices/prices-prop.vue")
  },
  {
    name: "pricing-fix-prices-prices",
    path: "/pricing/fix-prices/prices",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/fix-prices/prices.vue")
  },
  {
    name: "pricing-groups",
    path: "/pricing/groups",
    meta: index5H0Y5xI83JMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/groups/index.vue")
  },
  {
    name: "pricing-groups-prop",
    path: "/pricing/groups/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/groups/prop.vue")
  },
  {
    name: "pricing-manualrepricing-detail",
    path: "/pricing/manualrepricing/detail",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/manualrepricing/detail.vue")
  },
  {
    name: "pricing-manualrepricing",
    path: "/pricing/manualrepricing",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/manualrepricing/index.vue")
  },
  {
    name: "pricing-monitoring",
    path: "/pricing/monitoring",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/monitoring/index.vue")
  },
  {
    name: "pricing-politics",
    path: "/pricing/politics",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/politics/index.vue")
  },
  {
    name: "pricing-politics-prop",
    path: "/pricing/politics/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/politics/prop.vue")
  },
  {
    name: "pricing-postponed",
    path: "/pricing/postponed",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/postponed/index.vue")
  },
  {
    name: "pricing-prices",
    path: "/pricing/prices",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/prices/index.vue")
  },
  {
    name: "pricing-prices-prop",
    path: "/pricing/prices/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/prices/prop.vue")
  },
  {
    name: "pricing-pricetypes",
    path: "/pricing/pricetypes",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/pricetypes/index.vue")
  },
  {
    name: "pricing-pricetypes-prop",
    path: "/pricing/pricetypes/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/pricetypes/prop.vue")
  },
  {
    name: "pricing-products",
    path: "/pricing/products",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/products/index.vue")
  },
  {
    name: "pricing-products-prop",
    path: "/pricing/products/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/products/prop.vue")
  },
  {
    name: "pricing-regions",
    path: "/pricing/regions",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/regions/index.vue")
  },
  {
    name: "pricing-regions-prop",
    path: "/pricing/regions/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/regions/prop.vue")
  },
  {
    name: "pricing-regularpricing",
    path: "/pricing/regularpricing",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/regularpricing.vue")
  },
  {
    name: "pricing-stock",
    path: "/pricing/stock",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/stock/index.vue")
  },
  {
    name: "pricing-stock-prop",
    path: "/pricing/stock/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/stock/prop.vue")
  },
  {
    name: "pricing-supplier",
    path: "/pricing/supplier",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/supplier/index.vue")
  },
  {
    name: "pricing-supplier-prop",
    path: "/pricing/supplier/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/supplier/prop.vue")
  },
  {
    name: "pricing-unallocated-products",
    path: "/pricing/unallocated-products",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/pricing/unallocated-products/index.vue")
  },
  {
    name: "profile-profile",
    path: "/profile/profile",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/profile/profile/index.vue")
  },
  {
    name: "setting-functions",
    path: "/setting/functions",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/functions/index.vue")
  },
  {
    name: "setting-functions-prop",
    path: "/setting/functions/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/functions/prop.vue")
  },
  {
    name: "setting-grouptypes",
    path: "/setting/grouptypes",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/grouptypes/index.vue")
  },
  {
    name: "setting-grouptypes-prop",
    path: "/setting/grouptypes/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/grouptypes/prop.vue")
  },
  {
    name: "setting-monitoring-settings",
    path: "/setting/monitoring-settings",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/monitoring-settings/index.vue")
  },
  {
    name: "setting-parameters",
    path: "/setting/parameters",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/parameters/index.vue")
  },
  {
    name: "setting-parameters-prop",
    path: "/setting/parameters/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/parameters/prop.vue")
  },
  {
    name: "setting-price-event",
    path: "/setting/price-event",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/price-event/index.vue")
  },
  {
    name: "setting-price-levels",
    path: "/setting/price-levels",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/price-levels/index.vue")
  },
  {
    name: "setting-price-levels-prop",
    path: "/setting/price-levels/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/price-levels/prop.vue")
  },
  {
    name: "setting-pricetype-groups",
    path: "/setting/pricetype-groups",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/pricetype-groups/index.vue")
  },
  {
    name: "setting-pricetype-groups-prop",
    path: "/setting/pricetype-groups/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/pricetype-groups/prop.vue")
  },
  {
    name: "setting-product-statuses",
    path: "/setting/product-statuses",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/product-statuses/index.vue")
  },
  {
    name: "setting-product-statuses-prop",
    path: "/setting/product-statuses/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/product-statuses/prop.vue")
  },
  {
    name: "setting-region-groups",
    path: "/setting/region-groups",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/region-groups/index.vue")
  },
  {
    name: "setting-region-groups-prop",
    path: "/setting/region-groups/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/region-groups/prop.vue")
  },
  {
    name: "setting-repricing-options",
    path: "/setting/repricing-options",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/repricing-options/index.vue")
  },
  {
    name: "setting-repricing-options-prop",
    path: "/setting/repricing-options/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/repricing-options/prop.vue")
  },
  {
    name: "setting-schedule",
    path: "/setting/schedule",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/schedule/index.vue")
  },
  {
    name: "setting-schedule-prop",
    path: "/setting/schedule/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/schedule/prop.vue")
  },
  {
    name: "setting-stock-levels",
    path: "/setting/stock-levels",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/stock-levels/index.vue")
  },
  {
    name: "setting-stock-levels-prop",
    path: "/setting/stock-levels/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/stock-levels/prop.vue")
  },
  {
    name: "setting-tables",
    path: "/setting/tables",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/tables/index.vue")
  },
  {
    name: "setting-tables-prop",
    path: "/setting/tables/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/tables/prop.vue")
  },
  {
    name: "setting-tabletypes",
    path: "/setting/tabletypes",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/tabletypes/index.vue")
  },
  {
    name: "setting-tabletypes-prop",
    path: "/setting/tabletypes/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/tabletypes/prop.vue")
  },
  {
    name: "setting-value-parameters",
    path: "/setting/value-parameters",
    meta: indexgwzJEzngdfMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/value-parameters/index.vue")
  },
  {
    name: "setting-value-parameters-prop",
    path: "/setting/value-parameters/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/setting/value-parameters/prop.vue")
  },
  {
    name: "showcase-analytic",
    path: "/showcase/analytic",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/analytic/index.vue")
  },
  {
    name: "showcase-constellation",
    path: "/showcase/constellation",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/constellation/index.vue")
  },
  {
    name: "showcase-constellation-prop",
    path: "/showcase/constellation/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/constellation/prop.vue")
  },
  {
    name: "showcase-management",
    path: "/showcase/management",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/management/index.vue")
  },
  {
    name: "showcase-module",
    path: "/showcase/module",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/module/index.vue")
  },
  {
    name: "showcase-module-prop",
    path: "/showcase/module/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/module/prop.vue")
  },
  {
    name: "showcase-shop",
    path: "/showcase/shop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/shop/index.vue")
  },
  {
    name: "showcase-shop-prop",
    path: "/showcase/shop/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/shop/prop.vue")
  },
  {
    name: "showcase-showcase",
    path: "/showcase/showcase",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/showcase/index.vue")
  },
  {
    name: "showcase-showcase-prop",
    path: "/showcase/showcase/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/showcase/prop.vue")
  },
  {
    name: "showcase-template",
    path: "/showcase/template",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/template/index.vue")
  },
  {
    name: "showcase-template-prop",
    path: "/showcase/template/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/template/prop.vue")
  },
  {
    name: "showcase-type-module",
    path: "/showcase/type-module",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/type-module/index.vue")
  },
  {
    name: "showcase-type-module-prop",
    path: "/showcase/type-module/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/type-module/prop.vue")
  },
  {
    name: "showcase-type-showcase",
    path: "/showcase/type-showcase",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/type-showcase/index.vue")
  },
  {
    name: "showcase-type-showcase-prop",
    path: "/showcase/type-showcase/prop",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/showcase/type-showcase/prop.vue")
  },
  {
    name: "systemsetting-access",
    path: "/systemsetting/access",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/systemsetting/access/index.vue")
  },
  {
    name: "testing-function-test",
    path: "/testing/function-test",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/function-test/index.vue")
  },
  {
    name: "testing-loyalty-politic-test",
    path: "/testing/loyalty-politic-test",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/loyalty-politic-test/index.vue")
  },
  {
    name: "testing-marketing-politic-test",
    path: "/testing/marketing-politic-test",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/marketing-politic-test/index.vue")
  },
  {
    name: "testing-miner",
    path: "/testing/miner",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/miner/index.vue")
  },
  {
    name: "testing-politic-test-detail",
    path: "/testing/politic-test/detail",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/politic-test/detail.vue")
  },
  {
    name: "testing-politic-test",
    path: "/testing/politic-test",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/politic-test/index.vue")
  },
  {
    name: "testing-price-level-test",
    path: "/testing/price-level-test",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/price-level-test/index.vue")
  },
  {
    name: "testing-snake",
    path: "/testing/snake",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/snake/index.vue")
  },
  {
    name: "testing-some",
    path: "/testing/some",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/some/index.vue")
  },
  {
    name: "testing-tetris",
    path: "/testing/tetris",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/testing/tetris/index.vue")
  },
  {
    name: "workspace-assigned",
    path: "/workspace/assigned",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/workspace/assigned.vue")
  },
  {
    name: "workspace-inbox",
    path: "/workspace/inbox",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/workspace/inbox.vue")
  },
  {
    name: "workspace-tasks",
    path: "/workspace/tasks",
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/workspace/tasks.vue")
  },
  {
    name: "workspace-team",
    path: "/workspace/team",
    meta: teamhQUyNHjagWMeta || {},
    component: () => import("/var/www/pricing.bigam-dev.ru/data/www/client/pages/workspace/team.vue")
  }
]